<template>
  <header class="bg-slate-950/80 backdrop-blur-md border-b border-white/5 fixed w-full z-50 transition-all duration-300">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-20">
        <div class="flex-shrink-0 flex items-center group">
          <router-link to="/" class="flex items-center gap-2">
            <div class="w-10 h-10 bg-gradient-to-br from-emerald-400 to-blue-500 rounded-xl flex items-center justify-center shadow-lg group-hover:rotate-12 transition-transform">
              <span class="text-slate-950 font-black text-xl">
                <a href="/">
            <img alt="Logo" class="h-10 w-auto" :src="logo" />
          </a>
              </span>
            </div>
            <span class="text-xl font-black tracking-tighter text-white">prince<span class="text-emerald-400">Tech</span></span>
          </router-link>
        </div>

        <!-- Desktop Navigation -->
        <nav class="hidden md:flex items-center space-x-1">
          <router-link
            v-for="link in navLinks"
            :key="link.path"
            :to="link.path"
            class="text-slate-400 hover:text-emerald-400 px-4 py-2 text-sm font-bold transition-all hover:bg-white/5 rounded-xl"
            active-class="text-emerald-400 bg-emerald-500/10"
          >
            {{ link.name }}
          </router-link>
          
          <router-link
            to="/ContactUs"
            class="ml-4 px-6 py-2.5 bg-emerald-500 text-slate-950 text-sm font-black rounded-xl hover:bg-emerald-400 transition-colors shadow-[0_0_15px_rgba(16,185,129,0.2)]"
          >
            Get in touch
          </router-link>
        </nav>

        <!-- Mobile Menu Button -->
        <div class="md:hidden flex items-center">
          <button
            @click="toggleMobileMenu"
            class="text-slate-300 hover:text-emerald-400 w-12 h-12 flex items-center justify-center transition-colors rounded-xl bg-white/5"
          >
            <Menu v-if="!isMobileMenuOpen" class="h-6 w-6" />
            <X v-else class="h-6 w-6" />
          </button>
        </div>
      </div>

      <!-- Mobile Navigation Menu -->
      <transition 
        enter-active-class="transition duration-200 ease-out" 
        enter-from-class="transform opacity-0 scale-95" 
        enter-to-class="transform opacity-100 scale-100" 
        leave-active-class="transition duration-100 ease-in" 
        leave-from-class="transform opacity-100 scale-100" 
        leave-to-class="transform opacity-0 scale-95"
      >
        <div v-show="isMobileMenuOpen" class="md:hidden absolute top-20 left-0 w-full bg-slate-950/95 backdrop-blur-xl border-b border-white/5 pb-8 px-4">
          <div class="flex flex-col space-y-2 pt-4">
            <router-link
              v-for="link in navLinks"
              :key="link.path"
              :to="link.path"
              @click="isMobileMenuOpen = false"
              class="text-slate-300 hover:text-emerald-400 block px-4 py-4 text-lg font-bold transition-colors border-b border-white/5 last:border-none"
              active-class="text-emerald-400 bg-emerald-500/5"
            >
              {{ link.name }}
            </router-link>
            <router-link
              to="/ContactUs"
              @click="isMobileMenuOpen = false"
              class="mt-4 w-full py-4 bg-emerald-500 text-slate-950 text-center font-black rounded-2xl shadow-lg"
            >
              Get In Touch
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </header>
</template>

<script setup>
import logo from "@/assets/logo.jpeg";

import { ref } from "vue";
import { Menu, X } from "lucide-vue-next";

const isMobileMenuOpen = ref(false);

const navLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/About" },
  { name: "Services", path: "/Services" },
  { name: "Tech Stack", path: "/TechStack" },
  { name: "Portfolio", path: "/PortFolio" },
];

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};
</script>
